import {
    persistActiveMovementDraftBeforeLogout,
    preserveMovementDraftsOnSessionExpiry,
} from '../pages/Movements/Movement/utils/movementDraftStorage'

const handleError = (error, navigate = null) => {
    console.log("Erro capturado:", error);

    if (error.response) {
        const responseData = error.response.data;
        const payload =
            responseData && typeof responseData === "object"
                ? responseData
                : {};
        const responseMessage =
            payload.message ||
            (typeof responseData === "string" ? responseData : null);

        console.error("Erro da API:", responseData);

        const status = error.response.status;

        if (status === 401) {
            persistActiveMovementDraftBeforeLogout();
            preserveMovementDraftsOnSessionExpiry();
            navigate?.('/login', { state: { message: 'Usuário não autenticado.' } });
        } else if (status === 403) {
            navigate?.('/dashboard', { state: { message: responseMessage || 'Acesso negado.' } });
        } else if (status === 404) {
            navigate('/404', { state: { message: 'Recurso não encontrado.' } });
        } else if (status === 400) {
            console.log(error)
            throw {
                success: false,
                message: responseMessage || 'Erro de validação da solicitação.',
                status,
                data: payload.errors || null,
            };
        } else if (status === 422) {
            const payload =
                error.response.data && typeof error.response.data === "object"
                    ? error.response.data
                    : {};

            // * O Laravel devolve { errors: { campo: [mensagens] } }, mas
            // * alguns endpoints devolvem { error: [mensagens] } ou o próprio
            // * mapa de mensagens. Normaliza tudo para { campo: mensagem }.
            const messages =
                payload.errors ??
                (payload.error !== undefined ? { error: payload.error } : payload);

            const errorObject = Object.entries(messages ?? {}).reduce(
                (acc, [key, value]) => {
                    acc[key] = Array.isArray(value) ? value[0] : value;
                    return acc;
                },
                {}
            );

            throw {
                success: false,
                message: "Erro de validação.",
                status,
                data: errorObject,
            };
        } else {
            throw {
                success: false,
                message: "Erro ao processar a solicitação.",
                status,
                data: payload.errors || null,
            };
        }
    } else if (error.request) {
        console.error("Sem resposta do servidor:", error.request);
        throw { success: false, message: "Sem resposta do servidor." };
    } else {
        console.error("Erro desconhecido:", error.message);
        throw { success: false, message: "Erro desconhecido." };
    }
};

export default handleError;
